<template>
	<BaseCmsPage v-slot="{page}">
		<CmsIntroContainer :page="page">
			<template #h1>
				<h1 v-if="page?.seo_h1">{{ page.seo_h1 }}</h1>
			</template>
		</CmsIntroContainer>
		<BaseEventEvents v-slot="{items}">
			<div class="publish">
				<div class="wider-wrapper">
					<div class="e-container p-items blog-cnt" v-if="items?.length">
						<PublishIndexEntry v-for="post in items" :item="post" :key="post.id" mode="events" />
					</div>
					<BaseCmsLabel v-else code="no_events" tag="div" />
				</div>
			</div>
		</BaseEventEvents>
	</BaseCmsPage>
</template>